// add redirect here
import { NOT_FOUND } from 'redux-first-router';
import { fetchData, isValid } from './utils';

//checkData is a function for handleDispatch to check if there is no data, which will drive a 404
//hence, lack of data returns true and valid data returns false - CONFUSING, SHOULD REFACTOR
//it really is confusing. who wrote this?
//chris did
//seriously? that's sad
//i know. just bring him something warm to drink in the afternoons and we'll get actual work done once he nods off
const checkData = (data, type) => {

  if (!isValid(data)) {
    if (isValid(type) && type.includes('SEARCH')) {
      return false;
    } else {
      return true;
    }
  }
  const { pageType } = data;
  if (pageType === 'lander') {
    const { category } = data;
    if (category !== 'article') {
      const { articles } = data;
      if (!isValid(articles)) {
        return true;
      }
    }
  }
  if (pageType === 'article') {
    if (!isValid(data.article)) {
      return true;
    }
    const { modules } = data.article[0];
    if (!isValid(modules)) {
      return true;
    }
  }
};

const handleDispatch = (dispatch, type, data) => {
  const noData = checkData(data, type);
  (noData) ? dispatch({ type: NOT_FOUND }) : dispatch({ type, payload: { data } });
};

// might want to group related routes together and import them instead (ex. gift-guide ones)
export default {
  PRIVACY: {
    path: '/dns',
    thunk: async (dispatch) => {
      dispatch({ type: 'PRIVACY_FETCHED' });
    },
  },
  PRIVACY_POLICY: {
    path: '/page/privacy-policy',
    thunk: async (dispatch) => {
      dispatch({ type: 'PRIVACY_POLICY_FETCHED' });
    },
  },
  TERMS: {
    path: '/page/terms',
    thunk: async (dispatch) => {
      dispatch({ type: 'TERMS_FETCHED' });
    },
  },
  EDITORIAL_POLICY: {
    path: '/page/editorial-policy',
    thunk: async (dispatch) => {
      dispatch({ type: 'EDITORIAL_POLICY_FETCHED' });
    },
  },
  CONTEST_RULES: {
    path: '/page/contest-rules',
    thunk: async (dispatch) => {
      dispatch({ type: 'CONTEST_RULES_FETCHED' });
    },
  },
  RSS: {
    path: '/rss/:readerCategory',
    thunk: async (dispatch, getState) => {
      // we don't need to make any additional dispatches to update the store and the view since the response isn't intended for the browser
      const {
        location: {
          payload: {
            readerCategory,
          },
        },
      } = getState();
      const data = await fetchData(`/api/rss/${readerCategory}`);
    },
  },
  HOME: {
    path: '/',
    thunk: async (dispatch, getState) => {
      dispatch({ type: 'LANDER_FETCHING' });
      const {
        location: {
          payload: {
            category,
          },
          query,
        },
      } = getState();
      const data = await fetchData(`/api/main`);
      handleDispatch(dispatch, 'LANDER_FETCHED', data);
    },
  },
  WOWSHOP: {
    path: '/wowshop',
    thunk: async (dispatch, getState) => {
      dispatch({ type: 'PAGE_FETCHING' });
      const {
        location: {
          payload: {
            slug,
          },
        },
      } = getState();
      const data = await fetchData(`/api/page/wowshop`);
      handleDispatch(dispatch, 'PAGE_FETCHED', data);
    },
  },
  LANDER: {
    path: '/:category',
    thunk: async (dispatch, getState) => {
      dispatch({ type: 'LANDER_FETCHING' });
      const {
        location: {
          payload: {
            category,
          },
          query,
        },
      } = getState();
      const isVertical = query ? query.isVertical : null;
      const apiUrl = isVertical ? `/api/${category}?isVertical=${isVertical}` : `/api/${category}`;
      const data = await fetchData(apiUrl);
      handleDispatch(dispatch, 'LANDER_FETCHED', data);
    },
  },
  COMMERCE_POLICY: {
    path: '/page/commerce-policy',
    thunk: async (dispatch, getState) => {
      dispatch({ type: 'PAGE_FETCHING' });
      const {
        location: {
          payload: {
            slug,
          },
        },
      } = getState();

      const data = await fetchData(`/api/page/commerce-policy`);
      handleDispatch(dispatch, 'PAGE_FETCHED', data);
    },
  },
  ABOUT_US: {
    path: '/page/about-us',
    thunk: async (dispatch, getState) => {
      dispatch({ type: 'PAGE_FETCHING' });
      const {
        location: {
          payload: {
            slug,
          },
        },
      } = getState();

      const data = await fetchData(`/api/page/about-us`);
      handleDispatch(dispatch, 'PAGE_FETCHED', data);
    },
  },
  PAGE: {
    path: '/page/:slug?',
    thunk: async (dispatch, getState, req) => {
      dispatch({ type: 'PAGE_FETCHING' });
      const {
        location: {
          payload: {
            slug,
          },
        },
      } = getState();

      const isDraft = isValid(req.action.meta.query) && isValid(req.action.meta.query.allowDraft);
      const data = await fetchData(`/api/page/${slug}${isDraft ? '/draft' : ''}`);
      handleDispatch(dispatch, 'PAGE_FETCHED', data);
    },
  },
  ARTICLE_DRAFT: {
    path: '/draft/:pageType/:id',
    thunk: async (dispatch, getState) => {
      dispatch({ type: 'DRAFT_FETCHING' });
      const {
        location: {
          payload: {
            pageType,
            id,
          },
        },
      } = getState();

      const data = await fetchData(`/api/draft/${pageType}/${id}`);
      handleDispatch(dispatch, 'DRAFT_FETCHED', data);
    },
  },
  ARTICLE: {
    path: '/:category/:article?',
    thunk: async (dispatch, getState, req) => {
      dispatch({ type: 'ARTICLE_FETCHING' });
      const {
        location: {
          payload: {
            category,
            article,
          },
        },
      } = getState();
      
      const isDraft = isValid(req.action.meta.query) && isValid(req.action.meta.query.allowDraft);
      // figure out how to pull query string from location.payload (might be a redux-first-router thing)
      const data = await fetchData(`/api/${category}/${article}${isDraft ? '/draft' : ''}`);
      handleDispatch(dispatch, 'ARTICLE_FETCHED', data);
    },
  },
};